import { Modal as ModalModule, Utils } from 'common';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import React from 'react';

const { Session } = Utils;
const { Modal } = ModalModule;

const ReturnLabelPreviewModal = ({ modalId, data = {} }) => {
	const { recipientName, notes = '' } = data;
	const { customerDetails } = Session.getAccountInfo();
	const { address, email } = isObject(customerDetails) ? customerDetails : {};

	const recipient = isString(recipientName) ? `${recipientName},` : ',';
	const senderName = isObject(address) ? address.name : '';
	const senderEmail = isString(email) && email !== '' ? ` (${email})` : '';

	return (
		<Modal
			modalId={modalId}
			header="Return Label Preview"
			className="history-return-label return-label-preview-modal"
			hideFooter
		>
			<div className="p-grid p-dir-col">
				<p className="p-col-12">
					<b>Hi {recipient}</b>
				</p>
				<p className="p-col-12">
					{senderName}
					{senderEmail} has sent a prepaid, printable return label to use when
					returning your merchandise.
				</p>
				<br />
				{/* <hr className="p-col-3" /> */}
				<p className="p-col-12">
					<i>&ldquo;{notes}&rdquo;</i>
					<br />
					<span className="recipient-name">
						<i>
							<b>- {senderName}</b>
						</i>
					</span>
				</p>
				<p className="p-col-12 download-link">
					Download your Prepaid Return Label
				</p>
				<div className="p-col-12 fine-print">
					<p>
						If the above button is not working, copy and paste the following
						link into your web browser.
					</p>
					<p className="sample-link">{`www.stamps.com/sample`}</p>
				</div>
			</div>
		</Modal>
	);
};

ReturnLabelPreviewModal.propType = {
	data: PropTypes.shape({
		recipientName: PropTypes.string,
		notes: PropTypes.string,
	}),
};

export default ReturnLabelPreviewModal;
